import { post } from '../axios'

/**
 * Redeem Kisan Card points against an order. Mirrors payBySpiceMoneyWallet, but hits
 * the Kisan Card debit endpoint. The order is resolved server-side from the KHETI
 * session (created by payByPaymentGateway with gateway=KHETI), so no order_id is
 * needed. Self-redemption in the buyer's own app carries no OTP (is_assisted=false).
 */
const payByKisanCard = async (sessionId: string, amount: number) => {
  try {
    await post('/payment/v1/kisan-card/debit', {
      session_id: sessionId,
      amount,
      is_assisted: false,
    })
    return true
  } catch {
    return false
  }
}

export default payByKisanCard
